<template>
  <div style="color: white;">
    <h1>Signing in with Google...m</h1>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import firebaseConfig from './firebaseConfig.js';

export default {
  name: 'GoogleAuth',
  data() {
    return {
      PARENT_FRAME: document.location.ancestorOrigins && document.location.ancestorOrigins[0] 
        ? document.location.ancestorOrigins[0] 
        : '*',  // Fallback to '*' if ancestorOrigins isn't available
      auth: null
    };
  },
  created() {
    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }
    this.auth = firebase.auth();
  },
  mounted() {
    window.addEventListener('message', this.handleMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage);
  },
  methods: {
    // Send response back to the parent frame with proper origin
    sendResponse(result) {
      if (this.PARENT_FRAME) {
        // Make sure the result is serialized to a string
        // window.parent.postMessage(JSON.stringify(result), this.PARENT_FRAME);
        window.parent.postMessage(JSON.stringify(result), '*');
      }
    },
    // Handle messages received from the parent frame
    handleMessage({ data }) {
      try {
        if (data && data.initAuth) {
          // Initiate Google Authentication
          const provider = new firebase.auth.GoogleAuthProvider();
          this.auth.signInWithPopup(provider)
            .then((userCredential) => {
              // Send successful response
              this.sendResponse({ success: true, user: userCredential.user });
            })
            .catch((error) => {
              // Send error response
              this.sendResponse({ success: false, error: error.message });
            });
        }
      } catch (error) {
        console.error('Error processing message:', error.message);
        this.sendResponse({ success: false, error: error.message });
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// google.vue?2d43d0cc